import selectors from '../../../common/constants/selectors';

const PERCENT_PRECISION = 8;

const calculateMediaWidth = ({ element, width, parentWidth }) => {
  if (element.matches(selectors.COMPOSITE_ITEM)) {
    return `${((width / parentWidth) * 100).toFixed(PERCENT_PRECISION)}%`;
  }

  return `${width}px`;
};

export default calculateMediaWidth;
